// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"CollegesPage_toolbar__3mrYc","add":"CollegesPage_add__1aEER","table":"CollegesPage_table__YHduC"};